export const convertCustomerPropertyName = (name) => {
  switch (name) {
    case "이메일":
      return "세금계산서발행 이메일";
    case "일반전화":
      return "연락처";
    case "기본주소":
      return "실주소(납품처 기준)";
    default:
      return name;
  }
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "-";
  // ^0\d{1,2}(-|\))\d{3,4}-\d{4}$ 패턴에 맞게 변환
  // 예: 010-1234-5678, 02-123-4567, 031)123-4567 등
  // 괄호가 있는 경우도 처리
  let cleaned = phoneNumber.replace(/\s+/g, "");
  // 괄호를 -로 변환
  cleaned = cleaned.replace(/\)/g, "-").replace(/\(/g, "");
  // 이미 하이픈이 있으면 그대로 반환
  if (/^0\d{1,2}(-|\))\d{3,4}-\d{4}$/.test(cleaned)) {
    return cleaned;
  }
  // 하이픈이 없는 경우 패턴에 맞게 변환
  if (cleaned.length === 11) {
    // 01012345678 -> 010-1234-5678
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  } else if (cleaned.length === 10) {
    if (cleaned.startsWith("02")) {
      // 0212345678 -> 02-1234-5678
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
    } else {
      // 0311234567 -> 031-123-4567
      return cleaned.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
    }
  } else if (cleaned.length === 9 && cleaned.startsWith("02")) {
    // 021234567 -> 02-123-4567
    return cleaned.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
  }
  return phoneNumber;
};

// 실시간 입력용 전화번호 포맷팅 함수
export const formatPhoneNumberInput = (value) => {
  if (!value) return "";

  // 숫자만 추출
  const numbersOnly = value.replace(/[^\d]/g, "");

  // 최대 11자리까지만 허용
  const truncated = numbersOnly.slice(0, 11);

  if (truncated.startsWith("02")) {
    // 서울 지역번호 (02) 처리
    if (truncated.length <= 2) {
      return truncated;
    } else if (truncated.length <= 5) {
      // 02-123 형태
      return `${truncated.slice(0, 2)}-${truncated.slice(2)}`;
    } else if (truncated.length <= 9) {
      // 02-123-4567 형태 (3자리 국번)
      return `${truncated.slice(0, 2)}-${truncated.slice(
        2,
        5
      )}-${truncated.slice(5)}`;
    } else {
      // 02-1234-5678 형태 (4자리 국번)
      return `${truncated.slice(0, 2)}-${truncated.slice(
        2,
        6
      )}-${truncated.slice(6)}`;
    }
  } else if (
    truncated.startsWith("010") ||
    truncated.startsWith("011") ||
    truncated.startsWith("016") ||
    truncated.startsWith("017") ||
    truncated.startsWith("018") ||
    truncated.startsWith("019")
  ) {
    // 휴대폰 번호 처리
    if (truncated.length <= 3) {
      return truncated;
    } else if (truncated.length <= 7) {
      // 010-1234 형태
      return `${truncated.slice(0, 3)}-${truncated.slice(3)}`;
    } else {
      // 010-1234-5678 형태
      return `${truncated.slice(0, 3)}-${truncated.slice(
        3,
        7
      )}-${truncated.slice(7)}`;
    }
  } else {
    // 기타 3자리 지역번호 처리 (031, 032, 033, 041, 042, 043, 044, 051, 052, 053, 054, 055, 061, 062, 063, 064)
    if (truncated.length <= 3) {
      return truncated;
    } else if (truncated.length <= 6) {
      // 031-567 형태
      return `${truncated.slice(0, 3)}-${truncated.slice(3)}`;
    } else if (truncated.length <= 10) {
      // 031-567-9999 형태 (3자리 국번)
      return `${truncated.slice(0, 3)}-${truncated.slice(
        3,
        6
      )}-${truncated.slice(6)}`;
    } else {
      // 031-5679-9999 형태 (4자리 국번)
      return `${truncated.slice(0, 3)}-${truncated.slice(
        3,
        7
      )}-${truncated.slice(7)}`;
    }
  }
};
